export default __webpack_public_path__ + "static/media/linea-ecommerce-10.fd5a9ac1.eot";